import styled, { createGlobalStyle } from "styled-components";

import { info } from "./NavBar.info";

export const GlobalStyle = createGlobalStyle`
  :root {
    ${info.cssVarHeaderHeight}: ${info.headerHeight.default}px;

    ${props => props.theme.breakpointsV2.smallTablet} {
      ${info.cssVarHeaderHeight}: ${info.headerHeight.smallTablet}px;
    }

    ${props => props.theme.breakpointsV2.smallDesktop} {
      ${info.cssVarHeaderHeight}: ${info.headerHeight.smallDesktop}px;
    }
  }
`;

export const Header = styled.header`
  position: relative;
  height: var(--nav-bar-height);
  padding-top: ${props => props.theme.spacing.spacing_8};
  padding-bottom: ${props => props.theme.spacing.spacing_12};
  border-bottom: 1px solid ${props => props.theme.palette.blue50};
  background: ${props => props.theme.palette.white};
  z-index: ${props => props.theme.zIndex.header};

  ${props => props.theme.breakpointsV2.smallTablet} {
    padding-top: ${props => props.theme.spacing.spacing_16};
  }
`;

export const Body = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  grid-template-rows: 100%;
  gap: ${props => props.theme.spacing.spacing_24};
  align-items: flex-end;

  ${props => props.theme.breakpointsV2.smallTablet} {
    gap: ${props => props.theme.spacing.spacing_32};
  }
`;
